import { Injectable } from '@angular/core';
import { conformToMask } from 'angular2-text-mask';

@Injectable({
  providedIn: 'root'
})
export class FormatService {
  constructor() {}

  /**
   * Strips out the country code (+1) and parses the phone number for readability
   * ex. +12818812342 -> (281) 881-2342
   *
   * @param phone_number The original phone number
   */
  applyPhoneMask(phone_number: string): string {
    if (!phone_number) return null;
    return conformToMask(
      phone_number.substr(2),
      ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      { guide: false }
    ).conformedValue;
  }

  /**
   * Converts phone number to E.164 format which the back-end enforces
   */
  convertPhoneNumber(phoneNumber: string): string {
    return phoneNumber ? '+1' + phoneNumber.replace('(', '').replace(')', '').replace(' ', '').replace('-', '') : '';
  }

  /**
   * Formats the recipient information based on the destination type.
   *
   * @param destinationType the destination type
   * @param recipient       the recipient string
   * @returns The recipient string after format
   */
  formatDestinationRecipient(destinationType: string, recipient: string): string {
    switch (destinationType) {
      case 'fax':
        return this.applyPhoneMask(recipient);
      case 'email':
        return recipient;
      default:
        if (recipient) {
          return `${recipient} Folder`;
        } else {
          return '';
        }
    }
  }
}
